import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { pipe } from 'fp-ts/function';
import { array, record, option } from 'fp-ts';
import { Stack } from '@optimus-web/core';
import { ApplicationState, OccupancyData } from '@mews-commander/types';
import { getSortedAgeCategoryIdsByServiceId } from '@mews-commander/legacy-entities/src/ducks/ageCategories';
import { NoItems, SummaryRowBody } from '../../SummaryRow';
import { AgeCategoryName } from '../../../../../../../components/commander-ui';

interface StateProps {
    ageCategoryIds: string[];
}
interface OwnProps {
    occupancyData: Record<string, OccupancyData> | null;
    serviceId: string;
}

const GuestCountBodyAgeCategories = ({ occupancyData, ageCategoryIds }: OwnProps & StateProps) => {
    if (!occupancyData) {
        return <NoItems />;
    }

    return (
        <Stack vertical spacing="100">
            {pipe(
                ageCategoryIds,
                array.filterMap((id) =>
                    pipe(
                        occupancyData,
                        record.lookup(id),
                        option.fold(
                            () => option.none,
                            ({ personCount }) =>
                                option.some(
                                    <SummaryRowBody
                                        count={personCount}
                                        text={<AgeCategoryName id={id} />}
                                        data-test-age-category-id={id}
                                    />
                                )
                        )
                    )
                )
            )}
        </Stack>
    );
};

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        ageCategoryIds: getSortedAgeCategoryIdsByServiceId,
    })
)(GuestCountBodyAgeCategories);
